export default __webpack_public_path__ + "static/gauge-blue-b82f355699de9e193fe804640c5f42c5.png";